export default "__VITE_ASSET__DbiGO$z$__"